import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import {
  obtenerSocios,
  setListadoSocios,
  setMessageError,
} from "../../sliceRedux/ValidarReserva.slice";
import { useSelector } from "react-redux";
import RenderToast from "../../componentes/RenderToast";
import Observation from "../../componentes/Observation";

const RevisarSociosConstitucion = (props) => {
  const { showLoader, hideLoader, dispatch, toast, codSolConstitucion } = props;
  const [globalFilter, setGlobalFilter] = useState("");
  const [bandejaSocios, setBandejaSocios] = useState([]);
  const listadoSocios = useSelector((state) => state.validar.listadoSocios);
  const messageError = useSelector((state) => state.validar.messageError);

  useEffect(() => {
    showLoader();
    dispatch(obtenerSocios(codSolConstitucion));
  }, []);

  useEffect(() => {
    if (listadoSocios.code === 200) {
      let listado = listadoSocios?.object?.listSocios ?? [];
      setBandejaSocios(listado);
    }

    return () => {
      hideLoader();
      dispatch(setListadoSocios({ ...listadoSocios, ...{ code: 0 } }));
    };
  }, [listadoSocios.code]);

  const renderHeader = (
    <div className="flex justify-content-between">
      <div>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText value={globalFilter} onChange={(e) => buscar(e)} placeholder="Buscar..." />
        </IconField>
      </div>
    </div>
  );

  const buscar = (e) => {
    const value = e.target.value;
    setGlobalFilter(value);

    if (value === "") {
      setBandejaSocios([...(listadoSocios?.object?.listSocios ?? [])]);
      return;
    }

    const filtro = listadoSocios?.object?.listSocios?.filter((item) => {
      return (
        item.nomCatTipoIdentificacion?.toUpperCase().includes(value.toUpperCase()) ||
        item.numIdentificacion?.toUpperCase().includes(value.toUpperCase()) ||
        item.nombres?.toUpperCase().includes(value.toUpperCase()) ||
        item.txtEmail?.toUpperCase().includes(value.toUpperCase()) ||
        item.numCelular?.toUpperCase().includes(value.toUpperCase()) ||
        item.numTelefono?.toUpperCase().includes(value.toUpperCase())
      );
    });

    setBandejaSocios(filtro);
  };

  const rowIndexTemplate = (rowData, column) => {
    return column.rowIndex + 1 + "";
  };

  useEffect(() => {
    if (messageError != "") {
      RenderToast(toast, "error", "Error", messageError);
      hideLoader();
    }
    return () => {
      dispatch(setMessageError(""));
    };
  }, [messageError]);

  return (
    <>
      <div className="card">
        <Observation observationValue={listadoSocios?.object?.observacion} />
        <DataTable
          header={renderHeader}
          className="p-datatable-responsive-demo"
          paginator
          rows={10}
          dataKey="codSolConstSocios"
          loading={undefined}
          value={bandejaSocios}
          emptyMessage="Sin registros que mostrar."
          columnResizeMode="fit"
          style={{ width: "100%", overflow: "auto!important" }}
        >
          <Column
            body={rowIndexTemplate}
            header="Nro."
            sortable
            sortField="codSolConstSocios"
            headerStyle={{ textAlign: "center" }}
            style={{ width: "3%" }}
            bodyStyle={{
              textAlign: "center",
            }}
          />
          <Column
            field="nomCatTipoIdentificacion"
            header="Tipo de identificación"
            sortable
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            field="numIdentificacion"
            header="Identificación"
            sortable
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            field="nombres"
            header="Apellidos y nombres"
            sortable
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            field="numCelular"
            header="Celular"
            sortable
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            field="numTelefono"
            header="Teléfono"
            sortable
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            field="txtEmail"
            header="Correo electrónico"
            sortable
            headerStyle={{ textAlign: "center" }}
          />
        </DataTable>
      </div>
    </>
  );
};
export default RevisarSociosConstitucion;
